import { gql } from "apollo-angular";

const FILTER_PAYMENT_STATUS = gql`
query paymentStatus($companiesIds: [ID]!) {
	paymentStatus(companiesIds: $companiesIds) {
		companyId
		isBlocked
		daysSinceLastPayment
		lastPayment
	}
}`;

export {
	FILTER_PAYMENT_STATUS
}